var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.348,
    height: 13.798,
    viewBox: "0 0 10.348 13.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "form_2_",
    "data-name": "form (2)",
    d: "M7.024,5.749a1.725,1.725,0,1,0,0,3.449h2.3a1.725,1.725,0,1,0,0-3.449ZM9.9,7.474a.575.575,0,0,1-.575.575h-2.3a.575.575,0,0,1,0-1.15h2.3A.575.575,0,0,1,9.9,7.474Zm1.15,3.449a.575.575,0,0,1-.575.575h-4.6a.575.575,0,1,1,0-1.15h4.6A.575.575,0,0,1,11.049,10.923Zm1.458-9.129L11.554.842A2.856,2.856,0,0,0,9.521,0H5.875A2.878,2.878,0,0,0,3,2.875v8.049A2.878,2.878,0,0,0,5.875,13.8h4.6a2.878,2.878,0,0,0,2.875-2.875v-7.1a2.856,2.856,0,0,0-.842-2.033Zm-.813.813a1.782,1.782,0,0,1,.217.267H10.474V1.437a1.686,1.686,0,0,1,.267.217Zm.5,8.316a1.725,1.725,0,0,1-1.725,1.725h-4.6A1.725,1.725,0,0,1,4.15,10.923V2.875A1.725,1.725,0,0,1,5.875,1.15H9.324V2.875a1.15,1.15,0,0,0,1.15,1.15H12.2Z",
    transform: "translate(-3 0)",
    fill: "#ff643a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.b4999daf764a03c9614bdec34335f171.svg";
export { ForwardRef as ReactComponent };